import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
        <App />
      <Toaster position="top-right" reverseOrder={true} />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
document.addEventListener("DOMContentLoaded", function () {
  const isDark = localStorage.getItem("isDark");
  if (isDark) {
    document.body.style.backgroundColor = "#1a1a1e";
  } else {
    document.body.style.backgroundColor = "#F2F2F2";
  }
});

reportWebVitals();
